<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="CVs"
      :items-per-page="10"
      :footer-props="{'items-per-page-text': 'Số hồ sơ một trang'}"
      disable-sort
      :server-items-length="count"
      v-bind="this.$attrs"
      :options.sync="pagination"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} hồ sơ
      </template>

      <template v-slot:[`item.enrollDeadline`]="{item}">
        {{ item.enrollDeadline | getDeadline }}
      </template>

      <template v-slot:[`item.enrollmentFlag`]="{item}">
        <v-chip-group>
          <v-chip :color="item.enrollmentFlag | getEnrollmentFlagClor" label small>
            {{ item.enrollmentFlag | getEnrollmentFlagTitle }}
          </v-chip>
          <v-chip color="success" v-if="item.enrollmentRegisterState" outlined small>Đã ĐK nhập học</v-chip>
          <v-chip color="success" v-if="item.reserveRegisterState" outlined small>Đã ĐK dự khuyết</v-chip>
        </v-chip-group>
      </template>

      <template v-slot:[`item.actions`]="{item}">
        <v-btn @click="() => onUpdate(item)" color="admin" outlined v-if="!canViewOnly"> Thay đổi </v-btn>
      </template>
    </v-data-table>
    <UpdateDialog ref="update-dialog" @onRefresh="refresh" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import UpdateDialog from './UpdateDialog.vue'
const baseHeaders = [
  {text: 'Mã hồ sơ', value: 'code'},
  {text: 'Khối', value: 'type', align: 'center'},
  {text: 'Cơ sở', value: 'department'},
  {text: 'Tên thí sinh', value: 'name'},
  {text: 'SĐT tài khoản', value: 'parentUsername'},
  {text: 'Hạn đăng ký', value: 'enrollDeadline'},
  {text: 'Trạng thái', value: 'enrollmentFlag'},
  {text: 'Thao tác', value: 'actions', align: 'center'},
]

export default {
  components: {UpdateDialog},
  computed: {
    ...mapGetters('cv', ['CVs', 'count', 'filterParams']),
    ...mapGetters('auth', ['user']),
    headers() {
      return baseHeaders
    },
    canViewOnly() {
      return this.user.username === 'uyenpt'
    },
  },
  data: () => ({loading: false, pagination: {}}),
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.refresh((newOptions.page - 1) * newOptions.itemsPerPage, newOptions.itemsPerPage)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({fetchItems: 'cv/fetchCVs'}),
    getBaseQuery() {
      let query = {fromAdmin: true, adminQueryType: 'enrollPlan'}
      if (this.user.department === 'both') {
        if (!Object.keys(this.filterParams).includes('department_in'))
          query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
      } else query.department_in = [this.user.department, 'unset']
      return query
    },
    async refresh(_start = 0, _limit = 10) {
      this.loading = true
      await this.fetchItems({_start, _limit, ...this.getBaseQuery()})
      this.loading = false
    },
    onUpdate(item) {
      this.$refs['update-dialog'].openDialog(item)
    },
  },
  filters: {
    getDeadline: v => (!v ? '' : moment(v).format('DD/MM/YYYY HH:mm')),
    getEnrollmentFlagTitle: v => {
      switch (v) {
        case 'enroll':
          return 'Nhập học'
        case 'reserve':
          return 'Dự khuyết'
        default:
          return 'Đóng'
      }
    },
    getEnrollmentFlagClor: v => {
      switch (v) {
        case 'enroll':
          return 'success'
        case 'reserve':
          return 'warning'
        default:
          return 'error'
      }
    },
  },
}
</script>
